import { render, staticRenderFns } from "./ClubsItemList.vue?vue&type=template&id=67bc0472"
import script from "./ClubsItemList.vue?vue&type=script&lang=js"
export * from "./ClubsItemList.vue?vue&type=script&lang=js"
import style0 from "./ClubsItemList.vue?vue&type=style&index=0&id=67bc0472&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports